import styled from "styled-components";

let titleBarHeight = 80;

export const OverviewBigScreenWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: auto;
    color: #FFFFFF;
    letter-spacing: 2px;
    background-color: rgb(5, 12, 38);
`;

export const OverviewBigScreenInnerWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 850px;
    color: #FFFFFF;
    letter-spacing: 2px;
    background-image: url("/static/images/big-screen/electric-wheel/details-screen-background.png");
    background-size: cover;
`;

export const ScreenTitleBar = styled.div`
    position: absolute;
    z-index: 110;
    left: 0%;
    top: 0%;
    width: 100%;
    height: ${titleBarHeight-12}px;
    padding: 12px 20px 0px 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-around;
`;

export const OverviewBigScreenContent = styled.div`
    display: grid;
    position: absolute;
    top: calc(${titleBarHeight}px);
    width: 100%;
    height: calc(100% - ${titleBarHeight}px);
    padding: 0px 20px 32px 20px;
    overflow-x: hidden;
    overflow-y: hidden;
    grid-template-columns: 2fr 3fr 2fr;
    grid-template-rows: 30% 34% 34%;
    grid-gap: 10px;
    align-items: stretch;
    justify-items: stretch;
    box-sizing: border-box;
    z-index: 100;
`;

export const IntroductionVideoWrapper = styled.div`
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    box-sizing: border-box;
    z-index: 100;
`;

export const DeviceMapWrapper = styled.div`
    grid-column: 2 / 3;
    grid-row: 1 / 3;
    padding: 10px;
    box-sizing: border-box;
    position: relative;
    background-image: url(static/images/big-screen/electric-wheel/overview-map-border.png);
    background-size: 100% 100%;
    overflow: hidden;
`;

export const DeviceOnlineStatisticsWrapper = styled.div`
    grid-column: 3 / 4;
    grid-row: 1 / 2;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 100;
`;

export const DeviceAlarmStatisticsWrapper = styled.div`
    grid-column: 1 / 2;
    grid-row: 2 / 3;
    box-sizing: border-box;
    z-index: 100;
`;

export const DeviceListWrapper = styled.div`
    grid-column: 3 / 4;
    grid-row: 2 / 3;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 100;
`;

export const DeivceOnlineDurationWrapper = styled.div`
    grid-column: 1 / 2;
    grid-row: 3 / 4;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 100;
    position: relative;
`;

export const DeviceAnalyseWrapper = styled.div`
    grid-column: 2 / 3;
    grid-row: 3 / 4;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 100;
`;

export const DeviceTrafficStatisticsWrapper = styled.div`
    grid-column: 3 / 4;
    grid-row: 3 / 4;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 100;
`;
